import { trackedResultTypes } from '~~/search/common/js/client/analytics/results';

const RANKING_START = 1;

const listTypes = [
  'videosSnippet',
  'newsSnippet',
  'imagesSnippet',
];

const rankListItem = (rank) => (item) => ({
  ...item,
  rank,
});

const rankProductAd = (item, index) => ({ ...item, rank: index + 1 });

/**
 * Ranks the results, setting the `rank` prop as necessary.
 * For certain result types, includes their internal "items" in the ranking,
 * or ranks them separately. The components are responsible for rendering
 * the rank as the `data-rank` attribute.
 * @param {Iterable} results
 * @returns {Iterator}
 */
export default function* withRank(results) {
  let rank = RANKING_START;

  for (const { result, component, props } of results) {
    if (trackedResultTypes.includes(result.type)) {
      // these types consist of a list of items (carousel like). they count as 1 rank combined
      if (listTypes.includes(result.type)) {
        props.items = props.items.map(rankListItem(rank));
        props.rank = rank;
        rank += 1;
        yield { result, component, props };
        continue;
      }
      if (result.type === 'productAds') {
        // Product ad carousels have their own separate ranking
        props.items = props.items.map(rankProductAd);
        yield { result, component, props };
        continue;
      }

      props.rank = rank;
      yield { result, component, props };

      rank += 1;
    } else {
      yield { result, component, props };
    }
  }
}
